export class CallbackGroupEntry {

    constructor( id, callback ) {
        this.id = id;
        this.callback = callback;
    }

    /**
     * Triggers the execution of the callback.
     * 
     * @param  {...any} args - Any arguments and data to send to the callbacks as parameters.
     */
    async invoke( ...args ) {
        if ( this.callback ) {
            await this.callback( ...args );
        }
    }

    /**
     * Returns the id of the entry.
     * 
     * @returns {string} The id of the entry.
     */
    getId() {
        return this.id;
    }

    /**
     * Returns the callback that has been stored in the entry. An entry can
     * hold at most one callback at any given time.
     * 
     * @returns {function} The callback that was last set.
     */
    getCallback() {
        return this.callback;
    }

    /**
     * Returns whether or not a callback is set on the entry.
     * 
     * @returns {boolean} Whether or not a callback is set on the entry.
     */
    hasCallback() {
        return Boolean( this.getCallback() );
    }

}
